// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__vIokh","inputWrap":"Table_inputWrap__3q85G","col":"Table_col__2sYeF","bmiTooltip":"Table_bmiTooltip__1Rx7y"};